import React, { useEffect } from 'react';
import * as d3 from 'd3';
import { Data } from './types';
import { ChartMargin, initializeSvg, showTooltip, hideTooltip, tooltipDiv, addLabelForAxisX, addLabelForAxisY } from './utility';

const svgId = 'chart-tdp-over-mips';
const opts = {
    ChartWidth: 1024,
    ChartHeight: 576
};

const ProcessedData = Data.map(d => {
    const newD = {...d};
    newD.TDP_MIPS = (parseFloat(d.TDP || '0') / parseFloat(d.MIPS || '1')).toString();

    console.log(newD.TDP_MIPS);
    return newD;
});

const scaleY = d3.scaleLog()
    .domain([8e1, 1.4e-5])
    .range([opts.ChartHeight, 0]);

const ScaleX = d3.scaleLinear()
    .domain([1970, 2025])
    .range([0, opts.ChartWidth]);

const yAxis = d3.axisLeft(scaleY)
    .ticks(5)
    .tickFormat(d3.format('.5f'));

const AxisX = d3.axisBottom(ScaleX)
    .ticks(16)
    .tickFormat(d3.format('d'))
    .tickSizeOuter(0);

export default function TdpToMips() {
    useEffect(() => {
        initializeSvg(svgId, opts);

        d3.select(`svg[id=${svgId}]`)
            .append('g')
            .append('path')
            .datum([...ProcessedData] as any[])
            .attr('transform', `translate(${ChartMargin.left}, ${ChartMargin.bottom})`)
            .attr('fill', 'none')
            .attr('stroke', 'slategray')
            .attr("stroke-width", 2)
            .attr("d", d3.line()
                .x(d => ScaleX(parseInt((d as any).YEAR, 10)))
                .y(d => scaleY(parseFloat((d as any).TDP_MIPS || '0'))
            )).attr('data-class', 'line-connection');

        d3.select(`svg[id=${svgId}]`)
            .selectAll('dot')
            .data([...ProcessedData])
            .enter()
            .append('circle')
            .attr('fill', (d) => {
                const interpolater = d3.scaleLinear()
                    .domain([8, 0])
                    .range(['red', 'green'] as any)
                    .interpolate(d3.interpolateRgb as any);
                const color = interpolater(parseFloat((d as any).TDP_MIPS || '0'));
                return color;
            })
            .attr('transform', `translate(${ChartMargin.left}, ${ChartMargin.bottom})`)
            .attr('r', 5)
            .attr('cx', (d, i) => ScaleX(parseInt(d.YEAR, 10)))
            .attr('cy', (d, i) => scaleY(parseFloat((d as any).TDP_MIPS || '0')))
            .on('mouseover', (d, i, c) => {
                const circle = c[i];
                circle.setAttribute('r', '10');
                circle.setAttribute('stroke-width', '2');
                circle.setAttribute('stroke', 'slateBlue');
                showTooltip(tooltipDiv, d);

            }).on('mouseout', (d,i,c) => {
                const circle = c[i];
                circle.setAttribute('r', '5');
                circle.removeAttribute('stroke-width');
                circle.removeAttribute('stroke');
                hideTooltip(tooltipDiv);
            });

        d3.select(`svg[id=${svgId}]`)
            .append('g')
            .attr('transform', `translate(${ChartMargin.left}, ${ChartMargin.bottom})`)
            .call(yAxis);

        d3.select(`svg[id=${svgId}]`)
            .append('g')
            .attr('transform', `translate(${ChartMargin.left - 8}, ${opts.ChartHeight - 1 - ChartMargin.bottom})`)
            .call(AxisX);

        addLabelForAxisX('Year', svgId);
        addLabelForAxisY('Watt/MIPS', svgId);
    }, []);

    return (
        <div className="chart-container">
            <div className="container">
            <div className="row justify-content-center">
                    <h3>TDP in Watts to MIPS</h3>
                </div>
                <div className="row justify-content-center">
                    Measuring the effiency between watts per millions of instructions per second
                </div>
                <div className="row justify-content-center">
                    <svg id={svgId}></svg>
                </div>
            </div>
        </div>
    );
}